export interface PasswordRuleState {
    readonly key: string;
    readonly valid: boolean;
}

export const PASSWORD_SPECIAL_CHAR_PATTERN = /[@.&%$\u00B7_-]/;

export function buildPasswordRuleStates(password: string, confirmation: string): PasswordRuleState[] {
    return [
        {
            key: 'common.password-rules.min-length',
            valid: password.length >= 8,
        },
        {
            key: 'common.password-rules.uppercase',
            valid: /[A-Z]/.test(password),
        },
        {
            key: 'common.password-rules.lowercase',
            valid: /[a-z]/.test(password),
        },
        {
            key: 'common.password-rules.number',
            valid: /\d/.test(password),
        },
        {
            key: 'common.password-rules.special',
            valid: PASSWORD_SPECIAL_CHAR_PATTERN.test(password),
        },
        {
            key: 'common.password-rules.match',
            valid: password.length > 0 && password === confirmation,
        },
    ];
}

export function isPasswordStrong(password: string): boolean {
    return buildPasswordRuleStates(password, password).slice(0, 5).every((rule) => rule.valid);
}
